import axios from "./HttpRequestHotdeal";
//mobile
function  getlistCategory(param){
  return axios.post('/api/Donggiagiamgia2023/getlist_category', param);
}
function  getlistMucgia(param){
  return axios.post('/api/Donggiagiamgia2023/getlist_mucgia', param);
}
function  getlistProductV1(param){
  return axios.post('/api/Donggiagiamgia2023/getlist_product_v1', param);
}

export {getlistCategory,getlistMucgia,getlistProductV1}